module.exports = __webpack_public_path__ + "img/2.1fea4d59.jpg";